import { useEffect, useState } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import { StyleWrapper, StyleCard } from './style'
import { Transaction } from '@apis'
import Typography from '@components/typography'
import Column from '@components/column'
import Row from '@components/row'
import Container from '@components/container'
import Button from '@components/button'
const PaymentProcess = () => {
  const [searchParams] = useSearchParams()
  const [loading, setLoading] = useState<boolean>(false)
  const [payment, setPayment] = useState<any>({})
  const payload: any = {
    amount: searchParams.get('amount'),
    orderId: searchParams.get('orderId'),
    type: searchParams.get('type'),
    method: searchParams?.get('method'),
    createdBy: searchParams?.get('createdBy'),
    paidTo: searchParams?.get('paidTo'),
  }
  const pay = async () => {
    setLoading(true)
    const promoId = searchParams?.get('promoId')
    const payload: any = {
      amount: searchParams.get('amount'),
      orderId: searchParams.get('orderId'),
      type: searchParams.get('type'),
      method: searchParams?.get('method'),
      createdBy: searchParams?.get('createdBy'),
      paidTo: searchParams?.get('paidTo'),
    }
    if (!!promoId) {
      payload.promoId = promoId
    }
    await Transaction.pay({
      data: payload,
    })
      .then((resp) => {
        setPayment(resp)
      })
      .catch(() => {})

    setLoading(false)
  }

  useEffect(() => {
    pay()
  }, [])
  if (
    !payload?.amount ||
    !payload?.orderId ||
    !payload?.type ||
    !payload?.method ||
    !payload?.createdBy ||
    !payload?.paidTo
  ) {
    return <Navigate to="/" />
  }
  return (
    <StyleWrapper>
      <Container>
        {!!loading || !payment?.MERCHANTID ? (
          <Column justifyContent="center" rowGap={5}>
            <Typography
              content="PROCESSING..."
              size={32}
              styleText="  animation: zoomInOut 2s infinite ease-in-out;"
            />
          </Column>
        ) : (
          <form method="post" action={payment?.URL}>
            <input
              type="hidden"
              name="MERCHANTID"
              value={payment?.MERCHANTID}
            />
            <input type="hidden" name="APPID" value={payment?.APPID} />
            <input type="hidden" name="APPNAME" value={payment?.APPNAME} />
            <input type="hidden" name="TXNID" value={payment?.TXNID} />
            <input type="hidden" name="TXNDATE" value={payment?.TXNDATE} />
            <input type="hidden" name="TXNCRNCY" value={payment?.TXNCRNCY} />
            <input type="hidden" name="TXNAMT" value={payment?.TXNAMT} />
            <input
              type="hidden"
              name="REFERENCEID"
              value={payment?.REFERENCEID}
            />
            <input type="hidden" name="REMARKS" value={payment?.REMARKS} />
            <input type="hidden" name="TOKEN" value={payment?.TOKEN} />
            <input
              type="hidden"
              name="PARTICULARS"
              value={payment?.PARTICULARS}
            />
            <StyleCard>
              <Row justifyContent="space-between">
                <Typography content={'Payment Method'} size={16} />
                <Typography
                  content={`${payload?.method == 'connectIps' ? 'Connect Ips' : payload?.method}`}
                  size={16}
                />
              </Row>
              <Row justifyContent="space-between">
                <Typography content={'Amount'} size={16} />
                <Typography content={`Rs.${payment?.TXNAMT / 100}`} size={16} />
              </Row>
              <Row justifyContent="space-between">
                <Typography content={'TXN DATE'} size={16} />
                <Typography content={`${payment?.TXNDATE}`} size={16} />
              </Row>
              <Row justifyContent="space-between">
                <Typography content={'TXN ID'} size={16} />
                <Typography content={`${payment?.TXNID}`} size={16} />
              </Row>
              <Row justifyContent="space-between">
                <Typography content={'REFERENCE ID'} size={16} />
                <Typography content={`${payment?.REFERENCEID}`} size={16} />
              </Row>
              <Button
                title="Proceed"
                styleButton="width:100%;margin-top:30px;"
                styleButtonWrapper="width:100%;"
                height={40}
                type="submit"
              />
            </StyleCard>
          </form>
        )}
      </Container>
    </StyleWrapper>
  )
}

export default PaymentProcess
